import * as ActionTypes from './types';

export function resetState(payload) {
  return {
    type: ActionTypes.RESET_STATE,
    payload: payload
  }
}

export function openDrawer(payload) {
  return {
    type: ActionTypes.OPEN_DRAWER ,
    payload: payload
  }
}

export function closeDrawer(payload) {
  return {
    type: ActionTypes.CLOSE_DRAWER ,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/general.js